import { Container } from "@mui/material";
export default function PolitykaPrywatnosci() {
  return (
    <div className="max-w-3xl mx-auto p-6 leading-relaxed text-gray-800">
      <Container>
        <h1 className="text-2xl font-bold mb-6">Polityka Prywatności</h1>

        <section className="mb-4">
          <p>
            Administratorem danych osobowych jest właściciel serwisu
            <strong> twojaopiekunka.pl</strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Cel przetwarzania danych:
          </h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Założenie i prowadzenie konta opiekunki w serwisie.</li>
            <li>Publikacja profilu opiekunki.</li>
            <li>Umożliwienie kontaktu ze strony osób poszukujących opieki.</li>
            <li>
              Obsługa zapytań i zapewnienie prawidłowego działania serwisu.
            </li>
          </ul>
          <p className="mt-2 text-sm italic">
            Podanie danych jest dobrowolne, ale niezbędne do korzystania z
            funkcjonalności serwisu.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">
            Udostępnianie i przechowywanie:
          </h2>
          <p className="mb-2">
            Dane mogą być udostępniane użytkownikom serwisu (w zakresie profilu)
            oraz podmiotom wspierającym (hosting, IT).
          </p>
          <p>
            <strong>Okres przechowywania:</strong> Przez czas posiadania konta
            lub do momentu wycofania zgody / usunięcia konta.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-lg font-semibold mb-2">Twoje prawa:</h2>
          <p className="mb-2">Przysługuje Ci prawo do:</p>
          <ul className="list-disc pl-5 grid grid-cols-1 md:grid-cols-2 gap-1">
            <li>Dostępu do swoich danych i ich sprostowania.</li>
            <li>Usunięcia danych („prawo do bycia zapomnianym”).</li>
            <li>Ograniczenia przetwarzania i przenoszenia danych.</li>
            <li>Wniesienia sprzeciwu.</li>
          </ul>
        </section>

        <footer className="border-t pt-4 mt-6 text-sm text-gray-600">
          <p className="mb-2">
            Zgodę można wycofać w dowolnym momencie poprzez kontakt z
            administratorem lub usunięcie konta.
          </p>
          <p>
            W przypadku naruszenia przepisów przysługuje prawo wniesienia skargi
            do
            <strong> Prezesa Urzędu Ochrony Danych Osobowych</strong>.
          </p>
        </footer>
      </Container>
    </div>
  );
}
